export default __webpack_public_path__ + "images/0xeec468333ccc16d4bf1cef497a56cf8c0aae4ca3.png";